import React from 'react';
import { Grid, Box, IconButton, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

export default function AmountSelector({
    amount,
    increaseAmount,
    decreaseAmount,
    min = 1
}) {
    return (
        <Grid container alignItems="center" sx={{ paddingBottom: 14 }}>
            <Grid item xs={4}>
                <Box display="flex" justifyContent="right">
                    <IconButton onClick={decreaseAmount} disabled={amount <= min}>
                        <RemoveIcon fontSize="large" />
                    </IconButton>
                </Box>
            </Grid>

            <Grid item xs={4}>
                <Box display="flex" justifyContent="center">
                    <Typography variant="h3">{amount}</Typography>
                </Box>
            </Grid>

            <Grid item xs={4}>
                <Box display="flex" justifyContent="left">
                    <IconButton onClick={increaseAmount}>
                        <AddIcon fontSize="large" />
                    </IconButton>
                </Box>
            </Grid>
        </Grid>
    );
}
